import { ChevronDown } from 'lucide-react';
import React from 'react';

export type SortOption = 'relevance' | 'price_low' | 'price_high' | 'newest' | 'oldest';

interface BoatResultsHeaderProps {
    resultLabel?: string;
    totalResults: number;
    sortBy: SortOption;
    onSortChange: (sort: SortOption) => void;
}

const sortOptions: { value: SortOption; label: string }[] = [
    { value: 'relevance', label: 'Mais relevantes' },
    { value: 'price_low', label: 'Menor preço' },
    { value: 'price_high', label: 'Maior preço' },
    { value: 'newest', label: 'Mais recente' },
    { value: 'oldest', label: 'Mais antigo' },
];

export const BoatResultsHeader: React.FC<BoatResultsHeaderProps> = ({ resultLabel = 'anúncios encontrados', totalResults, sortBy, onSortChange }) => {
    return (
        <div className="mb-6 flex items-center justify-between">
            {/* Results Count */}
            <h2 className="text-lg font-medium text-gray-900">{/* {totalResults} {resultLabel} */}</h2>

            {/* Sort Dropdown */}
            <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Ordenar por:</span>
                <div className="relative">
                    <select
                        value={sortBy}
                        onChange={(e) => onSortChange(e.target.value as SortOption)}
                        className="cursor-pointer appearance-none rounded-lg border border-gray-300 bg-white py-2 pr-10 pl-3 text-sm text-gray-700 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    >
                        {sortOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <ChevronDown className="h-4 w-4 text-gray-400" />
                    </div>
                </div>
            </div>
        </div>
    );
};
